<template>
  <div class="dynamicform" v-if="itemData.formName">
    <div class="success" :class="{ successactive: formSent }">
        <h2 class="noto-semibold ttl">{{ $fn.tr("Thank You") }}</h2>

        <div class="txt">
            <template v-if="itemData.form_settings && itemData.form_settings.resultText && itemData.form_settings.resultText.length">
                {{ itemData.form_settings.resultText[locale]}}
            </template>
            <template v-else>
                {{ $fn.tr("contact form after submit thanks message") }}
            </template>
        </div>

        <button @click="formSent = false" class="success-btn">{{ $fn.tr("Reset") }}</button>
    </div>
    
    <template v-if="formData">
        <el-form v-if="formData.form_config && formData.form_config.length" ref="ruleForm" :model="ruleForm" :rules="rules">
            <template v-for="(field, index) in formData.form_config">
                <h2 v-if="field.type === 'title'" class="el-title" :class="{ hidden: field.confs && field.confs.includes('hidden') }">
                    <template v-if="field.title && field.title[locale]">
                        {{ field.title[locale] }}
                    </template>
                    <template v-if="field.content && field.content[locale]">
                        <br />
                        <span class="el-help-text" v-html="field.content[locale]"></span>
                    </template>
                </h2>

                <el-form-item v-else-if="field.type === 'radio' && field.values && Object.entries(field.values).length" :prop="field.name" :class="{ hidden: field.confs && field.confs.includes('hidden') }">
                    <div class="el-label noto-semibold" v-if="field.title && field.title[locale]">{{ field.title[locale] }}</div>

                    <el-radio-group v-model="ruleForm[field.name]">
                        <template v-for="option in Object.entries(field.values)">
                            <el-radio v-if="option[0] && option[1]" :label="option[0]">{{ option[1] }}</el-radio>
                        </template>
                    </el-radio-group>

                    <template v-if="field.helpText && field.helpText[locale]">
                        <span class="el-help-text-sm">{{ field.helpText[locale] }}</span>
                    </template>
                </el-form-item>

                <el-form-item v-else-if="field.type === 'text'" :prop="field.name" :class="{ hidden: field.confs && field.confs.includes('hidden') }">
                    <div class="el-label noto-semibold" v-if="field.title && field.title[locale]">{{ field.title[locale] }}</div>
                    <el-input v-model="ruleForm[field.name]" :placeholder="field.placeHolder && field.placeHolder[locale] ? field.placeHolder[locale] : ''"></el-input>
                    
                    <template v-if="field.helpText && field.helpText[locale]">
                        <span class="el-help-text-sm">{{ field.helpText[locale] }}</span>
                    </template>
                </el-form-item>

                <el-form-item v-else-if="field.type === 'select' && field.values && Object.entries(field.values).length" :prop="field.name" :class="{ hidden: field.confs && field.confs.includes('hidden') }">
                    <div class="el-label noto-semibold" v-if="field.title && field.title[locale]">{{ field.title[locale] }}</div>

                    <el-select v-model="ruleForm[field.name]" :placeholder="field.placeHolder && field.placeHolder[locale] ? field.placeHolder[locale] : ''" :popper-append-to-body="true">
                        <template v-for="option in Object.entries(field.values)">
                            <el-option v-if="option[0] && option[1]" :label="field.translate === '1' ? option[1][locale] : option[1]" :value="field.keyAsValue && field.keyAsValue === '1' ? option[0] : (field.translate === '1' ? option[1][locale] : option[1])"></el-option>
                        </template>
                    </el-select>

                    <template v-if="field.helpText && field.helpText[locale]">
                        <span class="el-help-text-sm">{{ field.helpText[locale] }}</span>
                    </template>
                </el-form-item>

                <el-form-item v-else-if="field.type === 'textarea'" :prop="field.name">
                    <div class="el-label noto-semibold" v-if="field.title && field.title[locale]">{{ field.title[locale] }}</div>

                    <el-input type="textarea" v-model="ruleForm[field.name]" :placeholder="field.placeHolder && field.placeHolder[locale] ? field.placeHolder[locale] : ''" resize="none"></el-input>
                    
                    <template v-if="field.helpText && field.helpText[locale]">
                        <span class="el-help-text-sm">{{ field.helpText[locale] }}</span>
                    </template>
                </el-form-item>

                <el-form-item v-else-if="field.type === 'number'" :prop="field.name">
                    <div class="el-label noto-semibold" v-if="field.title && field.title[locale]">{{ field.title[locale] }}</div>

                    <el-input-number v-model="ruleForm[field.name]" controls-position="right" :min="0"></el-input-number>

                    <template v-if="field.helpText && field.helpText[locale]">
                        <span class="el-help-text-sm">{{ field.helpText[locale] }}</span>
                    </template>
                </el-form-item>

                <el-form-item v-else-if="field.type === 'checkbox'" :prop="field.name">
                    <template v-for="option in Object.entries(field.values)">
                        <el-checkbox :label="option[0]" v-model="ruleForm[field.name]">{{ option[1] }}</el-checkbox>
                    </template>
                </el-form-item>
            </template>

            <el-form-item class="submit-container">
                <!-- <div class="captcha">
                    <vue-recaptcha :sitekey="$store.state.indx.nocapcha.sitekey" :loadRecaptchaScript="true" @verify="onVerify"></vue-recaptcha>
                </div> -->

                <el-button type="primary" @click="onSubmit">გაგზავნა</el-button>
            </el-form-item>
        </el-form>
    </template>
  </div>
</template>

<script>
// import VueRecaptcha from "vue-recaptcha";

export default {
  name: "dynamicForm",
  components: {
    // VueRecaptcha,
  },
  props: {
    itemData: {},
  },
  data() {
    return {
      ruleForm: {},
      rules: {},
      formData: null,
      formSent: false,
    };
  },
  methods: {
    onSubmit() {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.validate(async (valid) => {
            if (valid) {
                let tmp = await this.$fn.postData("main/saveSubmitedForm", { ...this.ruleForm, formType: this.itemData.formName, dynamicForm: 1 });

                this.formSent = true;
                this.$refs.ruleForm.resetFields();
            } else {
              return false;
            }
          });
        }
    },
    validateEmail(rule, value, callback) {
        if (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(value)) {
            callback();
        } else {
            let errorText = this.formData.form_config.find(f => f.name === rule.field).validate.email.msg[this.locale];
            callback(new Error(errorText));
        }
    },
    validateNumber(rule, value, callback) {
        if (/^[1-9]\d*(\.\d+)?$/g.test(value)) {
            callback();
        } else {
            let errorText = this.formData.form_config.find(f => f.name === rule.field).validate.number.msg[this.locale];
            callback(new Error(errorText));
        }
    },
    validateMin(rule, value, callback) {
        let minNumber = Math.round(parseFloat(this.formData.form_config.find(f => f.name === rule.field).validate.min.value));
        let isNumberType = this.formData.form_config.find(f => f.name === rule.field).type === "number";

        if ((isNumberType ? value : value.length) < minNumber) {
            let errorText = this.formData.form_config.find(f => f.name === rule.field).validate.min.msg[this.locale];
            callback(new Error(errorText));
        } else {
            callback();
        }
    },
    validateMax(rule, value, callback) {
        let maxNumber = Math.round(parseFloat(this.formData.form_config.find(f => f.name === rule.field).validate.max.value));
        let isNumberType = this.formData.form_config.find(f => f.name === rule.field).type === "number";

        if ((isNumberType ? value : value.length) > maxNumber) {
            let errorText = this.formData.form_config.find(f => f.name === rule.field).validate.max.msg[this.locale];
            callback(new Error(errorText));
        } else {
            callback();
        }
    },
    normalizeData(data) {
        let formObj = {};
        let ruleObj = {};

        for (let i = 0; i < data.length; i++) {
            if (!data[i].name) continue;

            formObj[data[i].name] = "";

            if (data[i].type === "radio" && data[i].preselectedValues && Object.keys(data[i].preselectedValues).length) {
                formObj[data[i].name] = Object.keys(data[i].preselectedValues)[0];
            }

            if (data[i].type === "select" && data[i].preselectedValues && Object.keys(data[i].preselectedValues).length) {
                formObj[data[i].name] = Object.keys(data[i].preselectedValues)[0];
            }

            if (data[i].validate.required && data[i].validate.required.status) {
                ruleObj[data[i].name] = [
                    {
                        required: true,
                        message: data[i].validate.required.msg[this.locale],
                        trigger: "blur"
                    }
                ]
            }

            if (data[i].validate.email && data[i].validate.email.status) {
                ruleObj[data[i].name] = [
                    ...ruleObj[data[i].name],
                    {
                        validator: this.validateEmail,
                        trigger: "blur"
                    }
                ]
            }

            if (data[i].validate.number && data[i].validate.number.status) {
                ruleObj[data[i].name] = [
                    ...ruleObj[data[i].name],
                    {
                        validator: this.validateNumber,
                        trigger: "blur"
                    }
                ]
            }

            if (data[i].validate.min && data[i].validate.min.status) {
                ruleObj[data[i].name] = [
                    ...ruleObj[data[i].name],
                    {
                        validator: this.validateMin,
                        trigger: "blur"
                    }
                ]
            }

            if (data[i].validate.max && data[i].validate.max.status) {
                ruleObj[data[i].name] = [
                    ...ruleObj[data[i].name],
                    {
                        validator: this.validateMax,
                        trigger: "blur"
                    }
                ]
            }
        }

        this.ruleForm = formObj;
        this.rules = ruleObj;
    },
    async getFormFields() {
        let req = await this.$fn.postData("main/getFormBuilderForm", { form_name: this.itemData.formName });

        if (req.status === 200 && req.data.form_config && req.data.form_config.length) {
            this.formData = req.data;
            this.normalizeData(req.data.form_config);
        }
    },
    scrollInit() {
        ['touchmove', 'mousewheel', 'wheel', 'scroll'].forEach((eventType) => {
            let stop = document.querySelectorAll('.el-select-dropdown__list');
            let stop1 = document.querySelectorAll('.list-overflow');
            if (stop || stop1) {
                stop.forEach((item) => {
                    item.addEventListener(eventType, (e) => e.stopPropagation());
                });
                stop1.forEach((item) => {
                    item.addEventListener(eventType, (e) => e.stopPropagation());
                });
            }
        });
    },
    // onVerify(e) {
    //   console.log(e);
    // }
  },
  computed: {
    locale() {
        return this.$store.state.locale
    },
  },
  mounted() {
    this.getFormFields();

    setTimeout(() => {
        this.scrollInit();
    }, 1000);
  },
};
</script>
